import axios from 'axios';

import type {ApiContext} from './types';

const AUTHORIZATION_FAILURE_STATUS_CODES = [401, 403];

export function handleCopyError(ctx: ApiContext, error: unknown) {
  const status = axios.isAxiosError(error) ? error.response?.status : undefined;
  if (status !== undefined && AUTHORIZATION_FAILURE_STATUS_CODES.includes(status)) {
    ctx.handleApiError(error);
  }
  return ctx.handleMutationError(error);
}
